import edapWrapper from '@homeaway/edap-wrapper';
import haWrapper from './ha-wrapper';
import {post} from './fetch-wrapper';

export const GENERIC_EVENT = 'generic.event';
export const TEST_EXPOSURE = 'test.exposure';
export const PAGE_VIEW = 'pageview';
export const PRIMARY_ACTION_RENDERED = 'primary.action.rendered';
export const PAGE_TRIPBOARD_MAIN = 'tripboards main';
export const PAGE_TRIPBOARD_DETAILS = 'tripboards tripboard details';
export const PAGE_TRIPBOARD_DETAILS_MAP = 'tripboards tripboard details map';
export const PAGE_RECENT_ACTIVITY_DETAILS = 'tripboards recentactivity details';
export const PAR_METRIC_NAME = 'primaryActionRendered';
import {ROLES} from './constants';

const getEdapRoleFromRole = (role = '') => {
    let edapRole = role;
    if (edapRole === ROLES.OWNER) {
        edapRole = ROLES.ADMIN; /* hacky hack because 'OWNER' is not a valid enum in named events  TODO: remove this when edap updates with OWNER in accesstype enum*/
    }

    return edapRole.toLowerCase();
}

const getPositionLabel = (position, total) => {
    return `position=${position + 1};total=${total}`;
};

const getTotal = (total) => {
    return `total=${total}`;
};

const logMetric = (metric, metricLogName) => {
    const loadTimeAnalytics = haWrapper.userTiming.getEntriesByName(metric);
    const metricMark = Math.ceil(
        loadTimeAnalytics.length ? loadTimeAnalytics[0].startTime : 0
    );
    const urlPrefix = haWrapper.apiPrefix;

    if (urlPrefix && metricLogName) {
        post(`/${urlPrefix}/api/metrics`, {
            [metricLogName]: metricMark
        });
    }
};

const markPAR = () => {
    haWrapper.userTiming.mark(PRIMARY_ACTION_RENDERED);
    logMetric(PRIMARY_ACTION_RENDERED, PAR_METRIC_NAME);
};

export const trigger = (name, data, options) => {
    edapWrapper().push({
        name,
        data,
        options
    });
};

const pageview = (pagename) => {
    if (typeof window !== 'undefined' && window.analyticsdatalayer && pagename) {
        window.analyticsdatalayer = {
            ...window.analyticsdatalayer,
            pagename
        };
        trigger(PAGE_VIEW);
    }
};

export default {
    getPositionLabel,
    getEdapRoleFromRole,
    getTotal,
    logMetric,
    markPAR,
    pageview,
    trigger
};



// WEBPACK FOOTER //
// ./src/universal/utils/edap.js